// app/middleware/notFoundWorldCup.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "world-cup") {
    throw createError({ statusCode: 404 });
  }
});
